var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { createUIElement, SPACING_M } from "../../helpers";
import { DashboardPlate } from "../../DashboardPlate";
import { DashboardPlateContext } from "../../DashboardPlate/context";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", " {\n        margin-top: ", ";\n        margin-right: ", ";\n    }\n"], ["\n    ", " {\n        margin-top: ", ";\n        margin-right: ", ";\n    }\n"])), DashboardPlate.selector, SPACING_M, SPACING_M);
export var DashboardLayout = createUIElement('DashboardLayout', function (_a, ref) {
    var className = _a.className, children = _a.children, ui = _a.ui, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "children", "ui", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (React.createElement(DashboardPlateContext.Provider, { value: {
            viewMoreIcon: ui === null || ui === void 0 ? void 0 : ui.viewMoreIcon,
            viewMoreText: ui === null || ui === void 0 ? void 0 : ui.viewMoreText
        } },
        React.createElement(Wrapper, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'dashboard-layout', className: "vm-DashboardLayout " + className, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), children)));
});
var templateObject_1;
//# sourceMappingURL=DashboardLayout.js.map